module.exports = __webpack_public_path__ + "static/media/one.e4233874.svg";